module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-white.2b26c5fb.svg";